import { FC } from 'react';
import { Button } from '../form/Button';
import { Modal } from '../modal/Modal';
import { ModalProps } from '../modal/useModal';
import { Card } from '../sections/Card';

export interface UnsavedChangesModalProps {
  onCancelCallback: () => void;
  onConfirmCallback: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmColorClass?: string;
  cancelColorClass?: string;
}

export const UnsavedChangesModal: FC<ModalProps & UnsavedChangesModalProps> = ({
  onCancelCallback,
  onConfirmCallback,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes. Are you sure you want to leave?',
  confirmText = 'Leave without saving',
  cancelText = 'Cancel',
  confirmColorClass,
  cancelColorClass,
  ...props
}) => {
  const { close, ...rest } = props;

  const onClose = () => {
    onCancelCallback();
    close();
  };

  const onConfirm = () => {
    onConfirmCallback();
    close();
  };

  return (
    <Modal className="md:max-w-xl" close={onClose} {...rest}>
      <Card className="w-full p-8">
        <div className="flex flex-col gap-2">
          <Modal.Controls close={onClose} {...rest}>
            <h1 className="text-2xl font-semibold">{title}</h1>
          </Modal.Controls>
          <div className="flex flex-col">
            <p>{message}</p>
            <div className="flex justify-end gap-3 mt-5 items-center">
              <Button onClick={onClose} className={cancelColorClass}>{cancelText}</Button>
              <Button onClick={onConfirm} className={confirmColorClass}>{confirmText}</Button>
            </div>
          </div>
        </div>
      </Card>
    </Modal>
  );
};
